import { useCallback } from 'react';
import { useCallbackOnInitAndResizeHook } from './use-callback-on-init-and-resize.hook';

/**
 * Compares current window width with threshold immediately and each window resize.
 *
 * Sets true if window width less than threshold. Otherwise - sets false.
 * For example, could be used to check if it is a mobile screen resolution (less than 1024px).
 * @param setIsWindowWidthLess Method to set comparison result
 * @param threshold
 */
export const useScreenWidthLessHook = ({
    setIsWindowWidthLess,
    threshold = 1024,
}) => {
    const compareWidths = useCallback(() => {
        if (typeof setIsWindowWidthLess !== 'function') {
            return;
        }

        const screenWidth = window.innerWidth;
        setIsWindowWidthLess(screenWidth < threshold);
    }, [setIsWindowWidthLess, threshold]);

    useCallbackOnInitAndResizeHook({ callback: compareWidths });
};
